import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main className="pt-20">
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-slate-900 mb-12">
              Mentions légales
            </h1>

            <div className="prose prose-lg max-w-none">
              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">1. Informations légales</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  <strong>Raison sociale :</strong> THE 21-DAY BUSINESS WEBSITE™, une marque de la société WEBSTORM<br />
                  <strong>Forme juridique :</strong> SARL<br />
                  <strong>Capital social :</strong> 5 000 €<br />
                  <strong>Siège social :</strong> Face au 9 quai du 4 septembre, 92100 Boulogne-Billancourt, FRANCE<br />
                  <strong>TVA intracommunautaire :</strong> FR74 800 226 094
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">2. Directeur de publication</h2>
                <p className="text-slate-600 leading-relaxed">
                  Le directeur de la publication du site est Marc SIGNOREL.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">3. Hébergement</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Le site est hébergé par :<br />
                  <strong>O2Switch</strong><br />
                  Service d'hébergement web professionnel Français
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">4. Propriété intellectuelle</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, etc.) est la propriété exclusive de THE 21-DAY BUSINESS WEBSITE™ ou de ses partenaires.
                </p>
                <p className="text-slate-600 leading-relaxed">
                  Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments est strictement interdite sans l'accord exprès par écrit de THE 21-DAY BUSINESS WEBSITE™.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">5. Protection des données personnelles</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                </p>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Les informations recueillies via les formulaires de contact sont destinées uniquement à THE 21-DAY BUSINESS WEBSITE™ pour le traitement de votre demande.
                </p>
                <p className="text-slate-600 leading-relaxed">
                  Pour exercer vos droits, vous pouvez nous contacter à l'adresse : contact@21daywebsite.com
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">6. Cookies</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. En naviguant sur ce site, vous acceptez l'utilisation de cookies.
                </p>
                <p className="text-slate-600 leading-relaxed">
                  Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">7. Responsabilité</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  THE 21-DAY BUSINESS WEBSITE™ s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, THE 21-DAY BUSINESS WEBSITE™ ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
                </p>
                <p className="text-slate-600 leading-relaxed">
                  THE 21-DAY BUSINESS WEBSITE™ ne pourra être tenue responsable des dommages directs ou indirects résultant de l'accès au site ou de l'utilisation du site.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">8. Liens hypertextes</h2>
                <p className="text-slate-600 leading-relaxed">
                  Ce site peut contenir des liens vers d'autres sites. THE 21-DAY BUSINESS WEBSITE™ n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">9. Droit applicable</h2>
                <p className="text-slate-600 leading-relaxed">
                  Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-3xl font-bold text-slate-900 mb-4">10. Contact</h2>
                <p className="text-slate-600 leading-relaxed">
                  Pour toute question concernant les mentions légales, vous pouvez nous contacter :<br />
                  <strong>Email :</strong> contact (at) 21dayswebsite.com
                </p>
              </section>

              <div className="mt-12 pt-8 border-t border-slate-200">
                <p className="text-sm text-slate-500">
                  Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
